import {
  ViewEncapsulation,
  ViewChild,
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  AfterViewInit,
  HostBinding
} from '@angular/core';
import { ITooltipPosition, ITooltipOptions } from './d3-tooltip.service';
import { D3TooltipHostDirective } from './d3-tooltip-host.directive';
export class D3TooltipComponent implements OnInit {

  
  component: any;

  
  position: ITooltipPosition;

  
  options: ITooltipOptions;

  
  inputs: any;

  
  outputs: any;
/**
 * Controls a class which sets the element opacity to 1 when present.
 */
isVisible = false;
/**
 * Element where the component gets inserted
 */
componentHost: D3TooltipHostDirective;
/**
 * @return {?}
 */
get cssTop() {
    return `${this.position.top}px`;
  }
/**
 * @return {?}
 */
get cssLeft() {
    return `${this.position.left}px`;
  }
/**
 * @return {?}
 */
get cssClasses() {
    return `${this.options.position} ${this.options.cssClasses}`;
  }
/**
 * @param {?} cfr
 */
constructor(private cfr: ComponentFactoryResolver) {
  }
/**
 * @return {?}
 */
loadComponent() {
    let /** @type {?} */ componentFactory = this.cfr.resolveComponentFactory(this.component);

    let /** @type {?} */ viewContainerRef = this.componentHost.viewContainerRef;
    viewContainerRef.clear();

    let /** @type {?} */ componentRef = viewContainerRef.createComponent(componentFactory);
    Object.keys(this.inputs).forEach(k => {
      componentRef.instance[k] = this.inputs[k];
    });
    Object.keys(this.outputs).forEach(k => {
      componentRef.instance[k].subscribe(this.outputs[k]);
    });
  }
/**
 * @return {?}
 */
ngOnInit() {
    setTimeout(() => {
      this.isVisible = true;
    }, 1);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'd3-tooltip',
  template: `
    <div class="ngx-d3-tooltip {{ cssClasses }}" [ngClass]="{ 'ngx-d3-tooltip_visible': isVisible }">
      <div class="arrow"></div>
      <ng-template d3TooltipHost></ng-template>
    </div>
  `,
  styles: [`
    d3-tooltip {
      position: absolute;
      width: 0;
      height: 0;
      overflow: visible;
      display: block;
    }
    d3-tooltip .ngx-d3-tooltip {
      display: inline-block;
      position: relative;
      background-color: #fff;
      border-color: #CCC;
      border-radius: 2px;
      -webkit-box-shadow: 0 1px 10px -3px rgba(0,0,0,0.3);
              box-shadow: 0 1px 10px -3px rgba(0,0,0,0.3);
      padding: 0.5rem 1rem;
      opacity: 0;
      -webkit-transition: opacity 0.2s ease-in;
      transition: opacity 0.2s ease-in;
      border: 1px solid #00000020;
    }
    d3-tooltip .ngx-d3-tooltip.ngx-d3-tooltip_visible {
      opacity: 1;
    }
    d3-tooltip .ngx-d3-tooltip .arrow {
      position: absolute;
      display: block;
      width: .8rem;
      height: .4rem;
    }
    d3-tooltip .ngx-d3-tooltip .arrow::before, d3-tooltip .ngx-d3-tooltip .arrow::after {
      position: absolute;
      display: block;
      border-color: #0000;
      border-style: solid;
      content: '';
      border-width: 10px;
    }
    /* TOP */
    d3-tooltip .ngx-d3-tooltip.top {
      -webkit-transform: translateX(-50%);
              transform: translateX(-50%);
      position: absolute;
      left: 0;
      bottom: 20px;
    }

    d3-tooltip .ngx-d3-tooltip.top .arrow {
      bottom: 0;
      left: 50%;
    }

    d3-tooltip .ngx-d3-tooltip.top .arrow::before {
      bottom: -20px;
      margin-left: -10px;
      border-top-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.top .arrow::after {
      bottom: -19px;
      margin-left: -10px;
      border-top-color: #fff;
    }

    /* BOTTOM */
    d3-tooltip .ngx-d3-tooltip.bottom {
      -webkit-transform: translateX(-50%);
              transform: translateX(-50%);
      position: absolute;
      left: 0;
      top: 20px;
    }

    d3-tooltip .ngx-d3-tooltip.bottom .arrow {
      top: 0;
      left: 50%;
    }

    d3-tooltip .ngx-d3-tooltip.bottom .arrow::before {
      top: -20px;
      margin-left: -10px;
      border-bottom-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.bottom .arrow::after {
      top: -19px;
      margin-left: -10px;
      border-bottom-color: #fff;
    }
    /* LEFT */
    d3-tooltip .ngx-d3-tooltip.left {
      -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
      position: absolute;
      right: 20px;
      top: 0;
    }

    d3-tooltip .ngx-d3-tooltip.left .arrow {
      right: 0;
      top: 50%;
    }

    d3-tooltip .ngx-d3-tooltip.left .arrow::before {
      right: -20px;
      margin-top: -10px;
      border-left-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.left .arrow::after {
      right: -19px;
      margin-top: -10px;
      border-left-color: #fff;
    }

    /* RIGHT */
    d3-tooltip .ngx-d3-tooltip.right {
      -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
      position: absolute;
      left: 20px;
      top: 0;
    }

    d3-tooltip .ngx-d3-tooltip.right .arrow {
      left: 0;
      top: 50%;
    }

    d3-tooltip .ngx-d3-tooltip.right .arrow::before {
      left: -20px;
      margin-top: -10px;
      border-right-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.right .arrow::after {
      left: -19px;
      margin-top: -10px;
      border-right-color: #fff;
    }

    /* TOPRIGHT */
    d3-tooltip .ngx-d3-tooltip.topRight {
      position: absolute;
      left: -15px;
      bottom: 20px;
    }

    d3-tooltip .ngx-d3-tooltip.topRight .arrow {
      bottom: 0;
      left: 15px;
    }

    d3-tooltip .ngx-d3-tooltip.topRight .arrow::before {
      bottom: -20px;
      margin-left: -10px;
      border-top-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.topRight .arrow::after {
      bottom: -19px;
      margin-left: -10px;
      border-top-color: #fff;
    }

    /* TOPLEFT */
    d3-tooltip .ngx-d3-tooltip.topLeft {
      position: absolute;
      right: -15px;
      bottom: 20px;
    }

    d3-tooltip .ngx-d3-tooltip.topLeft .arrow {
      bottom: 0;
      right: 15px;
    }

    d3-tooltip .ngx-d3-tooltip.topLeft .arrow::before {
      bottom: -20px;
      margin-right: -10px;
      border-top-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.topLeft .arrow::after {
      bottom: -19px;
      margin-right: -10px;
      border-top-color: #fff;
    }
    /* BOTTOMRIGHT */
    d3-tooltip .ngx-d3-tooltip.bottomRight {
      position: absolute;
      left: -15px;
      top: 25px;
    }

    d3-tooltip .ngx-d3-tooltip.bottomRight .arrow {
      top: 0;
      left: 15px;
    }

    d3-tooltip .ngx-d3-tooltip.bottomRight .arrow::before {
      top: -20px;
      margin-left: -10px;
      border-bottom-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.bottomRight .arrow::after {
      top: -19px;
      margin-left: -10px;
      border-bottom-color: #fff;
    }

    /* BOTTOMLEFT */
    d3-tooltip .ngx-d3-tooltip.bottomLeft {
      position: absolute;
      right: -15px;
      top: 25px;
    }

    d3-tooltip .ngx-d3-tooltip.bottomLeft .arrow {
      top: 0;
      right: 15px;
    }

    d3-tooltip .ngx-d3-tooltip.bottomLeft .arrow::before {
      top: -20px;
      margin-right: -10px;
      border-bottom-color: #00000040;
    }

    d3-tooltip .ngx-d3-tooltip.bottomLeft .arrow::after {
      top: -19px;
      margin-right: -10px;
      border-bottom-color: #fff;
    }
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'component': [{ type: Input },],
'position': [{ type: Input },],
'options': [{ type: Input },],
'inputs': [{ type: Input },],
'outputs': [{ type: Input },],
'componentHost': [{ type: ViewChild, args: [D3TooltipHostDirective, ] },],
'cssTop': [{ type: HostBinding, args: ['style.top', ] },],
'cssLeft': [{ type: HostBinding, args: ['style.left', ] },],
};
}

function D3TooltipComponent_tsickle_Closure_declarations() {
/** @type {?} */
D3TooltipComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
D3TooltipComponent.ctorParameters;
/** @type {?} */
D3TooltipComponent.propDecorators;
/** @type {?} */
D3TooltipComponent.prototype.component;
/** @type {?} */
D3TooltipComponent.prototype.position;
/** @type {?} */
D3TooltipComponent.prototype.options;
/** @type {?} */
D3TooltipComponent.prototype.inputs;
/** @type {?} */
D3TooltipComponent.prototype.outputs;
/**
 * Controls a class which sets the element opacity to 1 when present.
 * @type {?}
 */
D3TooltipComponent.prototype.isVisible;
/**
 * Element where the component gets inserted
 * @type {?}
 */
D3TooltipComponent.prototype.componentHost;
/** @type {?} */
D3TooltipComponent.prototype.cfr;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
